import { makeAutoObservable, observable } from "mobx";
import { enableStaticRendering } from "mobx-react";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

class ModalStore {
  modalData = {};

  isOpen = false;

  onModalCloseEvent;

  constructor() {
    makeAutoObservable(this, { modalData: observable.ref });
  }

  openModal = (modalData) => {
    this.modalData = modalData;
    this.isOpen = true;
  };

  closeModal = () => {
    this.isOpen = false;
  };

  clearModal = () => {
    this.modalData = {};
    this.closeModal();
    if (typeof this.onModalCloseEvent !== "function") return;
    this.onModalCloseEvent();
  };
}

export default ModalStore;
